import { AFFILIATE_ID_QUERY_PARAM_KEY } from '../definitions/AffiliateQueryParamKeys';
import getVisitorId from './getVisitorId';
import getAffiliateData from './getAffiliateData';
import getGoogleAnalyticsClientId from './getGoogleAnalyticsClientId';
import getReferrerURL from './getReferrerURL';


/** Get some metadata we tend to provide for things like lead submission. Contains helpful analytics information. */
function getRequestMetadata() {
    const affiliateData = getAffiliateData();

    const requestMetadata = {
        referrer: getReferrerURL() ?? undefined,
        heapIdentity: window?.heap?.identity ?? undefined,
        visitorId: getVisitorId() ?? undefined,
        ...(affiliateData?.[AFFILIATE_ID_QUERY_PARAM_KEY] && {
            affiliate: {
                [AFFILIATE_ID_QUERY_PARAM_KEY]: affiliateData[AFFILIATE_ID_QUERY_PARAM_KEY],
            },
        }),
    };

    try {
        Object.assign(requestMetadata, {
            gacid: getGoogleAnalyticsClientId() ?? undefined,
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Error obtaining Google Analytics client id:', e.message);
    }

    return requestMetadata;
}

export default getRequestMetadata;
